
const EVENT_TYPE = {
  TEST: 0,
  USER_DATA: 1,
  MAX_EVENT_TYPE: 1
}

const EventBus = {
  isInitialized: false,
  eventSubscriptions: {},
  initEventBus: () => {
    if (!EventBus.isInitialized) {
      EventBus.isInitialized = true;
      for (var eventName in EVENT_TYPE) {
        EventBus.eventSubscriptions[EVENT_TYPE[eventName]] = [];
      }
    }
  },
  validEvent: (eventType) => {
    return (eventType >= EVENT_TYPE.TEST && eventType <= EVENT_TYPE.MAX_EVENT_TYPE);
  },
  subscribeToEvents: (eventType, callback, callbackOwner) => {
    EventBus.initEventBus();
    if (EventBus.validEvent(eventType)) {
      EventBus.eventSubscriptions[eventType].push({callback: callback, owner: callbackOwner});
    }
  },
  unsubscribeFromEvents: (eventType, callbackOwner) => {
    EventBus.initEventBus();
    if (EventBus.validEvent(eventType)) {
      var i = EventBus.eventSubscriptions[eventType].length;
      while (i--) {
        if (EventBus.eventSubscriptions[eventType][i].owner === callbackOwner) {
          EventBus.eventSubscriptions[eventType].splice(i, 1);
        }
      }
    }
  },
  emit: (eventType) => {
    EventBus.initEventBus();
    if (EventBus.validEvent(eventType)) {
      for (var subscription in EventBus.eventSubscriptions[eventType]) {
        EventBus.eventSubscriptions[eventType][subscription].callback();
      }
    }
  }
}

export { EventBus, EVENT_TYPE }



// WEBPACK FOOTER //
// ./src/services/EventService.jsx